import React from 'react';
import { AiFillDelete, AiFillEdit } from 'react-icons/ai';
import { FaCheck, FaDownload } from 'react-icons/fa';
import { HiX } from 'react-icons/hi';
import TypeWriter from '../RevealrSummary/TypeWriter';

const QueryItems = ({
  queries,
  selectedQuery,
  onClickQuery,
  handleEmail,
  handleDelete,
  deleteOptions,
  handleCloseDelete,
  handleDeleteChat,
  handleDownload,
  editOptions,
  handleEdit,
  handleTitleChange,
  titleValue,
  handleCloseEdit,
  handleEditTitle,
  searchQuery,
}) => {
  const highlightText = (text, query) => {
    const regex = new RegExp(`(${query})`, 'gi'); // 'gi' for global and case-insensitive matching
    return text.replace(regex, '<span class="highlighted">$1</span>');
  };

  return (
    <React.Fragment>
      {queries && queries.length > 0
        ? queries.map((query) => {
            const isDelete = deleteOptions[query.id];
            const isEdit = editOptions[query.id];

            return isDelete || isEdit ? (
              <div
                className={`queriesList__chats ${
                  selectedQuery && selectedQuery.id === query.id
                    ? 'chatSelected'
                    : ''
                }`}
              >
                {isDelete ? (
                  'DELETE QUERY?'
                ) : (
                  <div className='queriesList__chats__title'>
                    <span className='queriesList__chats__queryTitle'>
                      <textarea
                        id='titleInput'
                        value={titleValue}
                        onChange={(e) => handleTitleChange(e.target.value)}
                        onKeyDown={
                          titleValue === ''
                            ? null
                            : (e) => {
                                if (e.key === 'Enter') {
                                  handleEditTitle(e);
                                }
                              }
                        }
                      />
                    </span>
                  </div>
                )}
                <div className='queriesList__icons'>
                  <button
                    className='queriesList__icons__button'
                    onClick={(e) =>
                      isDelete ? handleDeleteChat(e) : handleEditTitle(e)
                    }
                  >
                    <FaCheck />
                  </button>
                  <button
                    className='queriesList__icons__button'
                    onClick={(e) =>
                      isDelete
                        ? handleCloseDelete(e, query.id)
                        : handleCloseEdit()
                    }
                  >
                    <HiX />
                  </button>
                </div>
              </div>
            ) : (
              <div
                key={query.id}
                className={`queriesList__chats ${
                  selectedQuery && selectedQuery.id === query.id
                    ? 'chatSelected'
                    : ''
                }`}
                onClick={() => onClickQuery(query)}
              >
                <div className='queriesList__chats__title'>
                  <span className='queriesList__chats__queryTitle'>
                    {query.title ? (
                      searchQuery === '' || searchQuery === null ? (
                        <TypeWriter
                          classQuery='title'
                          isQuery={true}
                          text={query.title}
                          delay={20}
                        />
                      ) : (
                        <span
                          className='title'
                          dangerouslySetInnerHTML={{
                            __html: query.title
                              ? highlightText(query.title, searchQuery)
                              : 'New Query',
                          }}
                        />
                      )
                    ) : (
                      'New Query'
                    )}
                  </span>
                  <span className='queriesList__chats__queryDate'>
                    {query.created}
                  </span>
                </div>

                {selectedQuery && selectedQuery.id === query.id ? (
                  <div className='queriesList__icons'>
                    <button
                      className='queriesList__icons__button'
                      title='Edit Title'
                      onClick={(e) => handleEdit(e, query)}
                    >
                      <AiFillEdit />
                    </button>
                    {/* <button
                      className="queriesList__icons__button"
                      title="Email"
                      onClick={(e) => handleEmail(e, query)}
                    >
                      <AiTwotoneMail />
                    </button> */}
                    <button
                      className='queriesList__icons__button'
                      title='Download Query'
                      onClick={(e) => handleDownload(e, query)}
                    >
                      <FaDownload />
                    </button>
                    <button
                      className='queriesList__icons__button'
                      title='Delete'
                      onClick={(e) => handleDelete(e, query)}
                    >
                      <AiFillDelete />
                    </button>
                  </div>
                ) : null}
              </div>
            );
          })
        : null}
    </React.Fragment>
  );
};

export default QueryItems;
